/**
 * Enumeration that defines the available report types.
 * Each value of the enumeration represents a report type.
 * @readonly
 * @enum {string}
 */
export const REPORT_TYPE = {
    REVIEW: 'reviews',
    APPLICATION: 'application',
    BACKGROUND_CHECK: 'background-check',
}

/**
 * Mapping that associates each report type with its corresponding endpoint URL.
 * Each key in the object is a value from the REPORT_TYPE enumeration, and the value is the corresponding URL.
 * @type {Object.<string, string>}
 */
export const REPORT_TYPE_TO_ENDPOINT_MAP = Object.freeze({
    [REPORT_TYPE.REVIEW]: '/reviews/export/',
    [REPORT_TYPE.APPLICATION]: '/applications/export/',
    [REPORT_TYPE.BACKGROUND_CHECK]: '/background_check/export/',
})
